/**
 * Bundle entrypoint — `wwwroot/Scripts/amri-home.js`.
 *
 * Imported by every public-site page through `_Layout.cshtml`. Side-effects
 * on import:
 *   - Attaches `window.Amri` namespace
 *   - Registers `Amri.Home` (carousel + accordion init)
 *   - Attaches `window.HandleDeferredClick` (referenced by legacy onclick=)
 *
 * The init function `Amri.Home.init()` is called from `_Layout.cshtml` after
 * the bundle loads. FAQ accordion + deferred-click are auto-initialized on
 * DOMContentLoaded — they don't need explicit boot calls.
 */
import './amri'; // ensures `window.Amri` exists before downstream imports
import './home/init'; // registers Amri.Home
import { initFaqAccordion } from './chrome/faq-accordion';
import { initDeferredClick } from './chrome/deferred-click';
import { initMobileDrawer } from './chrome/mobile-drawer';
import { initSearchOverlay } from './chrome/search-overlay';
import { initClientLog } from './chrome/log';
import { initSocialShare } from './chrome/social';
import { initCartCounter } from './chrome/cart-counter';
import { initAddToCart } from './chrome/add-to-cart';
import { initPreloader } from './chrome/preloader';
import { initGetCertifiedHandler } from './home/getCertifiedHandler';
import { initStudyGuideAutoOpen } from './chrome/study-guide-popup';

function onReady(callback: () => void): void {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback);
    } else {
        callback();
    }
}

// Error logger attaches synchronously so it can catch script-tag errors
// that fire before DOMContentLoaded.
initClientLog();

onReady(() => {
    initFaqAccordion();
    initDeferredClick();
    initMobileDrawer();
    initSearchOverlay();
    initSocialShare();
    initCartCounter();
    initAddToCart();
    initPreloader();
    initGetCertifiedHandler();
    // Site-wide (amri-home.js loads on every page via _Layout); no-ops unless
    // the page rendered the study-guide modal with data-auto-open="true".
    initStudyGuideAutoOpen();
});
